import styled from "styled-components/native";

export const CardContainer = styled.View`
  width: 300px;
  height: 170px;
  background: #ff671d;
  border-radius: 15px;
`;
